// extracted by mini-css-extract-plugin
module.exports = {"centerAlign":"errorSection_centerAlign__131CK","title":"errorSection_title__ni2_A","button":"errorSection_button__hwiOo"};